import { render, staticRenderFns } from "./ShareDownload.vue?vue&type=template&id=71a44058&scoped=true"
import script from "./ShareDownload.vue?vue&type=script&lang=js"
export * from "./ShareDownload.vue?vue&type=script&lang=js"
import style0 from "./ShareDownload.vue?vue&type=style&index=0&id=71a44058&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a44058",
  null
  
)

export default component.exports